"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  portContacts: {
    portContacts: '口岸联系方式',
    company: '公司',
    complaintCenter: '投诉平台',
    issueTitle: '标题',
    type: '类型',
    issueDescription: '内容',
    contentInfo: '### 数据信息（必填）\n' + '- 功能页面：\n' + '- 查询条件：\n' + '- 账号：\n' + '\n' + '### 问题描述（无法理解工单，将直接关闭）\n',
    placeholderSA: '请输入',
    titleIsNull: '请输入标题',
    typeIsNull: '请选择建议类型',
    contentIsNull: '请输入内容',
    photoTips: '拖曳图片至上传按钮或者单击上传按钮(支持JPEG、JPG、PNG，单个图片不超过10M)',
    fileTips: '只能上传word/excel/pdf文件，且不超过10M',
    fileIsLarge: '上传文件大小不能超过 10MB!',
    fileNameIsLong: '上传文件名称不能超过100个字符',
    imageIsFalse: '上传的图片格式不正确',
    photoIsLarge: '上传图片文件大小不能超过 10MB!',
    tips_1: '温馨提示：',
    tips_2: '小技巧提高工单回复解决效率',
    tips_3: '(1) 必须提供详细数据，截图，操作步骤，不完整工单无法处理',
    tips_3_1: '(2) 财务数据包问题，请先找总部财务中心确认，无确认截图的工单将直接关闭',
    tips_4: '工单支持markdown语法格式化，注意内容的可读性，方便其他人员查阅',
    tips_5: '问题范围请局限现有功能范围内，扩展业务问题直接关闭',
    jobResponsibilities: 'SA 工作职责',
    name: '姓名',
    responsibilities: '职责',
    attachFile: '附件',
    createIssue: '提交',
    sureSubmit: '确定提交?',
    feedbackInfo: '反馈信息',
    success: '成功'
  }
};